export const getAuthHeaders = () => {
    return {
        'Accept': 'application/json',
    };
};
